(function ($) {
  var CookieNotice = (function () {
    var instance;

    function createInstance(config) {
      var _this = new Object();
      var _config = config;
      var _cookies;
      var _modal;
      var _notice;

      _this.init = function () {
        _cookies = _this.getCookies();
        //   _this.placeCookieCSS();
        _this.placeModal();
        _this.placeNotice();

        if (!_cookies || _cookies === undefined) {
          // _this.showModal();
          _this.showNotice();
        } else {
          _this.updateModal();
          _this.placeScripts();
        }

        _modal.find("button").on("click", function (e) {
          _cookies = _this.getAcceptedCookies();
          _this.setCookies();
          _this.hideModal();
          _this.placeScripts();
        });
        _notice.find("button.accept").on("click", function (e) {
          _this.acceptAllCookies();
          _cookies = _this.getAcceptedCookies();
          _this.setCookies();
          _this.hideModal();
          _this.hideNotice();
          _this.placeScripts();
        });

        $(".wedentify-cookies").on("click", function (e) {
          e.preventDefault();
          _this.showModal();
        });

        $(".cc-notice button.instellingen").on("click", function (e) {
          e.preventDefault();
          _this.showModal();
          _this.hideNotice();
        });
      };

      // _this.placeCookieCSS = function () {
      //   var href = window.location.origin+'/cookie/cookie.css';

      //   if (window.location.origin.indexOf('localhost') > -1) {
      //     href = 'http://localhost/wedentify/wedentify/cookie/cookie.css';
      //   }

      //   $("head").append('<link rel="stylesheet" href="'+href+'"  type="text/css" />');
      // };

      _this.placeModal = function () {
        // $("body").append(modal);
        _modal = $(".cc-modal");
      };
      _this.placeNotice = function () {
        // $("body").append(notice);
        _notice = $(".cc-notice");
      };

      _this.showModal = function () {
        _modal.removeClass("cc-modal-hide");
      };

      _this.showNotice = function () {
        _notice.removeClass("cc-notice-hide");
      };

      _this.hideModal = function () {
        _modal.addClass("cc-modal-hide");
      };
      _this.hideNotice = function () {
        _notice.addClass("cc-notice-hide");
      };

      _this.updateModal = function () {
        _modal.find("input").prop("checked", false);

        $.map(_cookies, function (cookie, idx) {
          _modal.find("input[value=" + cookie + "]").prop("checked", true);
        });
      };

      _this.setCookies = function () {
        localStorage.setItem("wedentify", JSON.stringify(_cookies));
      };

      _this.deleteCookies = function () {
        localStorage.removeItem("wedentify");
      };

      _this.getCookies = function () {
        return JSON.parse(localStorage.getItem("wedentify"));
      };

      _this.acceptAllCookies = function () {
        var cookieInput = _modal.find("input");
        $.each(cookieInput, function () {
          $(this).is(":checked", true);
        });
      };

      _this.getAcceptedCookies = function () {
        var cookies = [];

        if ($("#essentiele-cookies").is(":checked")) {
          cookies.push("essentieel");
        }

        if ($("#voorkeur-cookies").is(":checked")) {
          cookies.push("voorkeur");
        }

        if ($("#tracking-cookies").is(":checked")) {
          cookies.push("tracking");
        }

        return cookies;
      };

      _this.placeScripts = function () {
        for (var i = _cookies.length - 1; i >= 0; i--) {
          if (_cookies[i] === "essentieel") {
            _this.placeEssentieleScripts();
          }
          if (_cookies[i] === "voorkeur") {
            // _this.placeVoorkeurScripts();
          }
          if (_cookies[i] === "tracking") {
            // _this.placeTrackingScripts();
          }
        }
      };

      _this.placeEssentieleScripts = function () {
        var scripts = _config.essentieel;

        Object.entries(scripts).forEach(([script, id]) => {
          _this.placeScript(script, id);
        });
      };

      _this.placeScript = function (script, id) {
        var _ga;
        switch (script) {
          case "_ga":
            // _ga = '<script async src="https://www.googletagmanager.com/gtag/js?id=' + id + '"></script>'
            //   + '<script>'
            //   + 'window.dataLayer = window.dataLayer || [];'
            //   + 'function gtag(){dataLayer.push(arguments);}'
            //   + 'gtag(\'js\', new Date());'

            //   + 'gtag("config", "'+id+'", { "anonymize_ip": true })'
            //   + '</script>';
            break;
        }
        // $("head").append(_ga);
      };

      return _this;
    }

    return {
      getInstance: function (config) {
        if (!instance) {
          instance = createInstance(config);
        }
        return instance;
      },
    };
  })();

  var config = {
    essentieel: {
      // _ga: 'G-45XSR80HRH',
    },
    voorkeur: {},
    tracking: {},
  };

  var cookieNotice = CookieNotice.getInstance(config).init();
})(jQuery);
